<template>
  <div v-if="showAd" class="ad-container">
    <div class="ad-label">Advertisement</div>
    <div 
      class="adsbygoogle"
      :data-ad-client="adClient"
      :data-ad-slot="adSlot"
      :data-ad-format="adFormat"
      :data-full-width-responsive="fullWidth"
      :style="adStyle"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'AdBanner',
  props: {
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      default: 'auto'
    },
    fullWidth: {
      type: String,
      default: 'true'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  data() {
    return {
      adClient: 'ca-pub-3014871134295110',
      showAd: false
    }
  },
  computed: {
    adStyle() {
      return {
        display: 'block',
        width: this.width,
        height: this.height
      }
    }
  },
  mounted() {
    this.checkAdConsent()
  },
  methods: {
    checkAdConsent() {
      const consent = localStorage.getItem('cookie-consent')
      if (consent === 'all') {
        this.showAd = true
        this.$nextTick(() => {
          this.loadAd()
        })
      }
      
      // Listen for consent changes
      window.addEventListener('storage', (e) => {
        if (e.key === 'cookie-consent' && e.newValue === 'all') {
          this.showAd = true
          this.$nextTick(() => {
            this.loadAd()
          })
        } else if (e.key === 'cookie-consent' && e.newValue !== 'all') {
          this.showAd = false
        }
      })
    },
    loadAd() {
      try {
        if (window.adsbygoogle && window.adsbygoogle.loaded !== true) {
          (window.adsbygoogle = window.adsbygoogle || []).push({})
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Ad loading error:', e)
      }
    }
  }
}
</script>

<style scoped>
.ad-container {
  margin: 20px 0;
  text-align: center;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #e9ecef;
}

.ad-label {
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.adsbygoogle {
  background: transparent;
}

/* Responsive ad sizing */
@media (max-width: 768px) {
  .ad-container {
    margin: 15px 0;
    padding: 8px;
  }
}
</style>
